import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import seatmap from './seatmap';
var reducer = combineReducers({
    seatmap: seatmap,
});
var store = configureStore({
    reducer: reducer,
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            immutableCheck: {
                warnAfter: 100
            },
            serializableCheck: {
                warnAfter: 100
            }
        });
    },
});
export default store;
